import { EXTERNAL_LINKS } from '../constants/externalLinks';
import { filterExternalLinks } from './filterExternalLinks';
import { getExternalAppUrl } from './getExternalAppUrl';
import { openExternalApp } from './openExternalApp';

/**
 * Builds right-menu external links for apps the user can open via multiApp handoff.
 * @param {{ apps?: Array, sourcePoolName?: string, accessToken?: string }} params
 * @returns {Array<{ id: string, poolName: string, text: string, url: string, onClick: Function }>}
 */
export const getRightMenuExternalLinks = ({
  apps,
  sourcePoolName = '',
  accessToken
} = {}) =>
  filterExternalLinks(EXTERNAL_LINKS, apps, sourcePoolName).map(link => {
    const url = getExternalAppUrl(link.host, link.localhost);
    return {
      ...link,
      url,
      onClick: () =>
        openExternalApp({
          url,
          accessToken
        })
    };
  });
